import { useQuery } from '@apollo/react-hooks';
import { GET_APPLICANT_INFORMATION } from './GET_APPLICANT_INFORMATION.gql';
import type { GetApplicantInformation, ApplicantInformation } from './types';
import { checkInvalidDate } from '../../Application/graphql/ApplicationForm/checkInvalidDate';

export const useGetApplicantInformation = (
  applicantId: string,
): GetApplicantInformation => {
  const { data, loading, error, refetch } = useQuery(
    GET_APPLICANT_INFORMATION,
    {
      variables: { id: applicantId },
      skip: !applicantId,
      fetchPolicy: 'network-only',
    },
  );

  let applicant: ApplicantInformation = {
    email: '',
    givenName: '',
    surname: '',
    gender: '',
    dateOfBirth: '',
    identityType: '',
    identityDocumentNumber: '',
    identityDocumentType: '',
    nationality: '',
    province: '',
    addressCountryRegion: '',
    addressLine1: '',
    mobileNumber: '',
    telephoneNumber: '',
    id: '',
    disabilitySpecialType: '',
    disabilitySpecialDetail: '',
  };

  if (!loading) {
    const applicantData = data?.applicant ?? {};

    const {
      _id,
      email,
      name,
      gender,
      dateOfBirth,
      identity,
      nationality,
      province,
      addressCountryRegion,
      addressLine1,
      addressLine2 = '',
      addressLine3 = '',
      mobileNumber,
      telephoneNumber,
      disabilitySpecial,
    } = applicantData;

    applicant = {
      id: _id,
      email,
      givenName: name?.givenName ?? '',
      surname: name?.surname ?? '',
      chineseName: name?.chineseName ?? '',
      gender,
      dateOfBirth: checkInvalidDate(dateOfBirth) ? '' : String(dateOfBirth),
      identityType: identity?.identityType ?? '',
      identityDocumentType: identity?.identityDocumentType ?? '',
      identityDocumentNumber: identity?.identityDocumentNumber ?? '',
      nationality,
      province,
      addressCountryRegion,
      addressLine1,
      addressLine2,
      addressLine3,
      mobileNumber,
      telephoneNumber,
      disabilitySpecialType: disabilitySpecial?.disabilitySpecialType ?? 'NA',
      disabilitySpecialDetail:
        disabilitySpecial?.disabilitySpecialDetail ?? undefined,
    };
  }
  return {
    applicant,
    loading,
    error,
    refetch,
  };
};
